import * as React from "react";

export function Table() {
  return <div></div>;
}
